<div *ngIf="tooltipConfig"
     class="tracking-scripts__floating-tooltip"
     [style.top.px]="tooltipConfig.top"
     [style.left.px]="tooltipConfig.left">
  {{ tooltipConfig.message }}
</div>

<div class="tracking-scripts__form-card surface-card">
  <div class="tracking-scripts__form-header">
    <div>
      <h2>{{ formTitleKey | translate }}</h2>
    </div>
    <button type="button"
            class="ghost-btn compact"
            (click)="cancel()"
            aria-label="{{ 'trackingScripts.actions.cancel' | translate }}">×</button>
  </div>

  <div class="tracking-scripts__form">
    <!-- Name -->
    <label class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.name' | translate }} <span style="color: #dc2626;">*</span></span>
      <input type="text"
             [(ngModel)]="name"
             name="name"
             [placeholder]="'trackingScripts.fields.name' | translate">
    </label>

    <!-- Owner entity -->
    <label class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.publisherId' | translate }} <span style="color: #dc2626;">*</span></span>
      <select [ngModel]="publisherId"
              (ngModelChange)="onEntityChange($event)"
              name="publisherId"
              [disabled]="isEntityLocked"
              [class.readonly-field]="isEntityLocked">
        <option value="" disabled>{{ 'trackingScripts.fields.publisherIdPlaceholder' | translate }}</option>
        <option *ngFor="let entity of entityOptions" [value]="entity.value">{{ entity.label }}</option>
      </select>
    </label>

    <!-- Template -->
    <label class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.template' | translate }}</span>
      <select [(ngModel)]="template" name="template">
        <option value="tnc">TNC</option>
        <option value="retailor">Retailor Media</option>
      </select>
    </label>

    <!-- Scripts -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.scripts' | translate }}</span>
      <div class="tracking-scripts__providers-list">
        <label class="tracking-scripts__provider-option"
               *ngFor="let script of availableScripts">
          <input type="checkbox"
                 [checked]="isScriptSelected(script.value)"
                 (change)="toggleScript(script.value)">
          <span>{{ script.label }}</span>
        </label>
      </div>
    </div>

    <!-- Checkboxes row: Autostart, TCF, Publisher -->
    <div class="tracking-scripts__form-field">
      <span>Flags</span>
      <div class="tracking-scripts__checkboxes-row">
        <label class="tracking-scripts__checkbox-item">
          <input type="checkbox"
                 [(ngModel)]="autostart"
                 name="autostart">
          {{ 'trackingScripts.fields.autostart' | translate }}
        </label>
        <label class="tracking-scripts__checkbox-item">
          <input type="checkbox"
                 [(ngModel)]="tcf"
                 name="tcf">
          {{ 'trackingScripts.fields.tcf' | translate }}
        </label>
        <label class="tracking-scripts__checkbox-item"
               [class.is-disabled]="isProviderUsedElsewhere(publisherId)"
               [title]="isProviderUsedElsewhere(publisherId) ? ('trackingScripts.providers.publisherAlreadyInUse' | translate) : ''"
               (click)="isProviderUsedElsewhere(publisherId) ? showDisabledTooltip('__publisher__', $event) : null">
          <input type="checkbox"
                 [(ngModel)]="publisher"
                 name="publisher"
                 [disabled]="isProviderUsedElsewhere(publisherId)"
                 (change)="onPublisherToggle()">
          {{ 'trackingScripts.fields.publisher' | translate }}
        </label>
      </div>
    </div>

    <!-- Modules -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.modules' | translate }}</span>
      <div class="tracking-scripts__providers-list">
        <label class="tracking-scripts__provider-option"
               *ngFor="let mod of availableModules">
          <input type="checkbox"
                 [checked]="isModuleSelected(mod)"
                 (change)="toggleModule(mod)">
          <span>{{ mod }}</span>
        </label>
      </div>
    </div>

    <!-- Callback Script -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.callbackScript' | translate }}</span>
      <app-js-editor [(ngModel)]="callbackScript" name="callbackScript"
                     wrapperFirst="async function cb(data) {"
                     wrapperLast="}"></app-js-editor>
    </div>

    <!-- Prepare Script -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.prepareScript' | translate }}</span>
      <app-js-editor [(ngModel)]="prepareScript" name="prepareScript"
                     wrapperFirst="async function prepare() {"
                     wrapperLast="}"></app-js-editor>
    </div>

    <!-- Overwrite Script -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.overwriteScript' | translate }}</span>
      <app-js-editor [(ngModel)]="overwriteScript" name="overwriteScript"
                     wrapperFirst="{"
                     wrapperLast="}"></app-js-editor>
    </div>

    <!-- Status toggle -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.status' | translate }}</span>
      <div class="tracking-scripts__checkboxes-row">
        <label class="tracking-scripts__checkbox-item">
          <input type="radio"
                 [(ngModel)]="status"
                 name="status"
                 [value]="1">
          {{ 'trackingScripts.fields.statusActive' | translate }}
        </label>
        <label class="tracking-scripts__checkbox-item">
          <input type="radio"
                 [(ngModel)]="status"
                 name="status"
                 [value]="0">
          {{ 'trackingScripts.fields.statusInactive' | translate }}
        </label>
      </div>
    </div>

    <!-- Providers -->
    <div class="tracking-scripts__form-field">
      <span>{{ 'trackingScripts.fields.providers' | translate }}</span>
      <div class="tracking-scripts__providers-list" *ngIf="providers.length; else noProviders">
        <label class="tracking-scripts__provider-option"
               *ngFor="let provider of providers"
               [class.is-disabled]="isProviderUsedElsewhere(provider.ID)"
               [title]="isProviderUsedElsewhere(provider.ID) ? ('trackingScripts.providers.alreadyInUse' | translate) : ''"
               (click)="isProviderUsedElsewhere(provider.ID) ? showDisabledTooltip(provider.ID, $event) : null">
          <input type="checkbox"
                 [checked]="isProviderSelected(provider.ID)"
                 [disabled]="isProviderUsedElsewhere(provider.ID)"
                 (change)="toggleProvider(provider.ID)">
          <span>{{ provider.Name }}</span>
          <small style="color: #94a3b8; font-size: 0.75rem; margin-left: auto;">{{ provider.ID }}</small>
        </label>
      </div>
      <ng-template #noProviders>
        <p style="color: #94a3b8; font-size: 0.85rem; margin: 0;">—</p>
      </ng-template>
    </div>

    <!-- Configurazioni avanzate -->
    <div class="tracking-scripts__advanced">
      <button type="button"
              class="tracking-scripts__advanced-toggle"
              (click)="showAdvanced = !showAdvanced">
        {{ (showAdvanced ? 'trackingScripts.advanced.hide' : 'trackingScripts.advanced.show') | translate }}
        <span class="tracking-scripts__advanced-arrow" [class.open]="showAdvanced">▾</span>
      </button>

      <div class="tracking-scripts__advanced-body" *ngIf="showAdvanced">

        <!-- Exclude -->
        <div class="tracking-scripts__form-field">
          <span>{{ 'trackingScripts.fields.exclude' | translate }}</span>
          <div class="tracking-scripts__providers-list">
            <label class="tracking-scripts__provider-option"
                   *ngFor="let val of availableExcludes">
              <input type="checkbox"
                     [checked]="isExcludeSelected(val)"
                     (change)="toggleExclude(val)">
              <span>{{ val }}</span>
            </label>
          </div>
        </div>

        <!-- Fonts version -->
        <label class="tracking-scripts__form-field">
          <span>{{ 'trackingScripts.fields.fontsVersion' | translate }}</span>
          <select [(ngModel)]="fontsVersion" name="fontsVersion">
            <option *ngFor="let ver of availableFontsVersions" [value]="ver">
              {{ ver }}{{ ver === defaultFontsVersion ? ' (' + ('trackingScripts.fields.fontsVersionDefault' | translate) + ')' : '' }}
            </option>
          </select>
        </label>

        <!-- Snippet Append -->
        <div class="tracking-scripts__form-field">
          <span>{{ 'trackingScripts.fields.snippetAppend' | translate }}</span>
          <app-js-editor [(ngModel)]="snippetAppend" name="snippetAppend"
                         wrapperFirst=""
                         wrapperLast=""></app-js-editor>
        </div>

      </div>
    </div>

    <!-- Form actions -->
    <div class="tracking-scripts__form-actions">
      <button type="button"
              class="ghost-btn"
              (click)="cancel()"
              [disabled]="saving">
        {{ 'trackingScripts.actions.cancel' | translate }}
      </button>
      <button type="button"
              class="primary-btn"
              (click)="save()"
              [disabled]="saving">
        {{ saving ? ('common.processing' | translate) : ('trackingScripts.actions.save' | translate) }}
      </button>
    </div>
  </div>
</div>
